/**
 * PURPOSE: Estado de los flags de elegibles Rugby (FTR-0015) para toda la SPA.
 * RESPONSIBILITIES: Una sola consulta compartida (renovada al minuto) y un hook con { loading, submissionsEnabled,
 *   visibilityMode, startActionEnabled }. Mientras carga, nada nuevo se muestra (la planilla queda como hoy).
 * COLLABORATORS: rugbyLineupsService.js, AdminCompanySection.jsx, planilla Rugby.
 * ROUTE: winscore/src/hooks/useRugbyLineupsStatus.js
 */
import { useEffect, useState } from "react";

import { getRugbyLineupsStatus } from "../services/rugbyLineupsService.js";

const TTL_MS = 60 * 1000;
let cache = null;

export const loadRugbyLineupsStatus = () => {
  if (!cache || Date.now() - cache.at > TTL_MS) cache = { at: Date.now(), promise: getRugbyLineupsStatus() };
  return cache.promise;
};

export const useRugbyLineupsStatus = () => {
  const [state, setState] = useState({ loading: true, submissionsEnabled: false, visibilityMode: "off", startActionEnabled: false });
  useEffect(() => {
    let active = true;
    loadRugbyLineupsStatus().then((status) => {
      if (active) setState({ loading: false, ...status });
    });
    return () => {
      active = false;
    };
  }, []);
  return state;
};
